import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "input"]

  updateLabel() {
    if (!this.hasLabelTarget || !this.hasInputTarget) return

    const [file] = this.inputTarget.files
    this.labelTarget.textContent = file ? file.name : "Nicio imagine selectată"
  }
}
